import axios from "axios";
import API from "./API";
import { toast } from "react-toastify";



// Toast
// import emitter from "../EventEmitter";

// // import {logout} from './store/slices/auth'
// // import store from './store/index';
axios.defaults.baseURL = API.API;
// import { useAuth } from "hooks/auth/useAuth";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers["token"] = `Bearer ${token}`;
  }
  return config;
});
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    let message = error?.response?.data?.message;
    let statusCode = error?.response?.data?.status;
    let status = error?.response?.status;

    if (message && !statusCode) {
      toast.error(message);
    }

    // if(status == 403){
    //   useAuth().logout();
    // }

    return Promise.reject(error);
  }
);
